import { Alert, AlertTitle, Box, Button, Stack, Typography } from "@mui/material";
import { AlertSeverity } from "src/components/SeverityStatus";
import InvertedExclamationIcon from "src/assets/inverted_exclamation.svg";
import InstructionsIcon from "src/assets/icon_instructions.svg";
import CloseIconButton from "src/components/CloseIconButton";
import { isArray } from "lodash";

export const InstructionBox = ({
  title,
  handler,
  description
}: any) => {
  return (
    <Box 
      display='grid'
      gridTemplateColumns='0.4fr 10fr 0.3fr'
      sx={{ m: 2, py: 2, backgroundColor: '#cafdf5', borderRadius: 1 }} 
    >
      <InstructionsIcon style={{ justifySelf: 'center' }}/>
      <Stack direction="column">
        <Typography variant="button">{title}</Typography>
        <Typography variant="body2">{description}</Typography>
      </Stack>
      <CloseIconButton 
        size="small" 
        sx={{ position: 'absolute', right: '25px' }}  
        onClick={handler}
      />
    </Box>
  )
};

export const CommonHeader = ({
  itemIsValid,
  handler,
  name,
  sx,
  actions,
}: any) => {
  return (
    <Stack sx={{...sx}} direction="row" display="flex" spacing={1} alignItems="center">
      <Typography variant="h6">{name}</Typography>
      <Alert
        severity={itemIsValid ? AlertSeverity.SUCCESS : AlertSeverity.INFO}
        icon={false}
        sx={{
          height: '30px',
          fontSize: '0.75rem',
          textTransform: 'capitalize',
          cursor: 'pointer',
          alignItems: 'center',
          padding: 1,
          ml: -1,
          fontWeight: 'bold'
        }}
      >
        {itemIsValid ? 'Completed': 'In-Progress'}
      </Alert>
      <Button
        sx={{ backgroundColor: 'rgba(0, 184, 217, 0)', minWidth: '26px' }}
        onClick={handler}
        size="small"
        autoFocus={false}
      >
        <InvertedExclamationIcon color='#00b8d9'/>
      </Button>
      {actions}
    </Stack>
)};

export const ErrorContainer = ({
  showErrorContainer: show,
  errorContainerTitle: title,
  errorContainerList: errors = [],
}: any) => {
  if (show) {
    const filterErrors = errors.filter((i: any) => i.reasonNotValid !== null);
    return (
      <Alert severity="error" sx={{ margin: 2 }}>
        <AlertTitle>{title}</AlertTitle>
        {filterErrors?.length !== 0 &&
          <ul>
            {filterErrors && isArray(filterErrors) && filterErrors.map((err: any) => (
              <li key={err.id}>{err.reasonNotValid}</li>
            ))}
          </ul>
        }
      </Alert>
    );
  }

  return null;
};

export const LabelTab = ({ name, isRequired }: any) => (
  <Stack
    alignItems="flex-start"
    direction="column"
  >
    <Typography variant="button">
      {name}
    </Typography>
    <Typography variant="caption" color="GrayText">
      {isRequired && 'Required'}
    </Typography>
  </Stack>
);